<template>
  <form @submit.prevent="doSearch(true)" style="max-width:500px">
    <div class="grid-x grid-padding-x">
      <div class="cell auto">
        <div class="input-group">
          <input v-model="query" class="text long input-group-field" type="text" placeholder="Enter your query" />
          <div class="input-group-button">
            <button type="submit" class="button btn btn-dark-gray">Search</button>  
          </div>
        </div>
      </div>
      <div class="cell shrink">
        <dropdown-filter
          v-for="(filter, index) in filters"
          :key="index"
          :filter="filter"
          :value="getFilterValues(filter.id)"
          @set-filter="$emit('set-filter', $event)">
          <template #button>
          <div class="grid-x align-middle">
            <div class="cell shrink">
              <span v-html="$icons.get('filter', 'large')" style="margin-right:.3rem"></span>
            </div>
            <div class="cell auto">
              {{ filter.title }}
            </div>
          </div>
        </template>
        </dropdown-filter>
      </div>
    </div>
    
  </form>
</template>

<script>
import {_} from 'vue-underscore'
import DropdownFilter from '@/DropdownFilter.vue'

export default {
  name: 'SearchForm',
  components: {
    DropdownFilter
  },
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  methods: {
    doSearch () {
      this.$emit('do-search')
    },
    getFilterValues (filter_id) {
      let filter = _.find(this.params.filters, function(item) {
        return item.id == filter_id
      })

      if (filter) {
        return filter.values
      }
      return []
    }
  },
  computed: {
    config () {
      return this.$root.$options.config
    },
    filters () {
      if ('filters' in this.config) {
        return this.config.filters
      }
      return false
    },
    query: {
      get () {
        return this.params.query
      },
      set (val) {
        this.$emit('set-param', { name: 'query', value: val })
      }
    }
  }
}
</script>